export { default } from './CarrosEletricosParaVoce';
